import React from 'react';
import { getFormValues } from 'redux-form';
import { connect } from 'react-redux';

import { getList } from 'src/reducers/common/listReducer';
import { REDUCER_NAME } from 'src/reducers/employees/employees';
import { REDUCER_NAME as CLIENT_REDUCER_NAME } from 'src/reducers/clients/clients';
import { takeEmployeesSearchQueries, FORM_NAME_EMPLOYEES_SEARCH } from 'src/reducers/searchForm';
import SortableTh from 'src/components/SortableTh';
import { EMPLOYEE_SHOW } from 'src/constants/EndpointUrls';
import { redirectTo, detailUrlWithQueries, getIdsFromArr } from 'src/utils/Http';
import EmployeeTableRow from 'src/features/Employees/components/EmployeeTableRow';
import { useTranslation } from 'react-i18next';

const EmployeeTable = ({ employees, queries }) => {
  const { t, i18n } = useTranslation();
  return (
    <div className="l-overflow-scroll">
      <table className="m-table-list">
        <thead>
          <tr>
            <th>{t('features.EmployeeBonus.components.EmployeeBonusTable.note')}</th>
            <SortableTh field="staffCode" globalClassName="m-table-list-staffcode" formName={FORM_NAME_EMPLOYEES_SEARCH}>
              {t('features.EmployeeBonus.components.EmployeeBonusTable.staff_code')}
            </SortableTh>
            <SortableTh field="name" formName={FORM_NAME_EMPLOYEES_SEARCH}>
              {t('features.EmployeeBonus.components.EmployeeBonusTable.name')}
            </SortableTh>
            <SortableTh field="clientBranchId" formName={FORM_NAME_EMPLOYEES_SEARCH}>
              {t('features.Employees.containers.EmployeeTable.belong')}
            </SortableTh>
            <SortableTh field="employmentTypeId" formName={FORM_NAME_EMPLOYEES_SEARCH}>
              {t('features.EmployeeBonus.components.EmployeeBonusTable.employment_type')}
            </SortableTh>
            <SortableTh field="groupId" formName={FORM_NAME_EMPLOYEES_SEARCH}>
              {t('features.Employees.components.BusinessInfoSection.group')}
            </SortableTh>
            <SortableTh field="positionId" formName={FORM_NAME_EMPLOYEES_SEARCH}>
              {t('features.Employees.components.BusinessInfoSection.position')}
            </SortableTh>
            <SortableTh field="joinedOn" formName={FORM_NAME_EMPLOYEES_SEARCH}>
              {t('features.Employees.components.BusinessInfoSection.first_day_of_work')}
            </SortableTh>
            <SortableTh field="resignedOn" formName={FORM_NAME_EMPLOYEES_SEARCH}>
              {t('features.Employees.components.BusinessInfoSection.retirement_date')}
            </SortableTh>
          </tr>
        </thead>
        <tbody>
          {(!employees || employees.length === 0) && (
            <tr>
              <td colSpan={7}>{t('features.EmployeeBonus.components.EmployeeBonusTable.no_data')}</td>
            </tr>
          )}

          {employees.map(employee => (
            <EmployeeTableRow
              key={employee.id}
              onClick={() =>
                redirectTo(detailUrlWithQueries(employee.id, queries, EMPLOYEE_SHOW, getIdsFromArr(employees)))
              }
              {...{ employee }}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = state => ({
  employees: getList(REDUCER_NAME, state),
  queries: takeEmployeesSearchQueries(getFormValues(FORM_NAME_EMPLOYEES_SEARCH)(state))
});

export default connect(mapStateToProps)(EmployeeTable);
